import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css'
import i18n from '@/plugins/i18n';
import { safeHtml } from '@/services/safeHtml'



import router from './router/index.ts';
const app = createApp(App);
app.directive('safe-html', safeHtml)
app.config.devtools = true;
app.use(router);
app.use(i18n);
app.mount('#app');

